import clsx from "clsx";
import { Search, X } from "lucide-react";
import type { SearchInputProps } from "./types";

export const SearchInput = ({
  id,
  name,
  value,
  onChange,
  placeholder,
  className,
  autoFocus = false,
}: SearchInputProps) => {
  return (
    <div className={clsx("relative", className)}>
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Search className="h-5 w-5 text-gray-400" />
      </div>
      <input
        type="text"
        id={id}
        name={name}
        autoFocus={autoFocus}
        className="block w-full pl-10 pr-8 py-2 rounded-md border border-gray-300 bg-white placeholder-gray-500 focus:outline-none focus:border-blue-500 focus:placeholder-gray-400 sm:text-sm"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
};
